import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = (props, ref) => /* @__PURE__ */ React.createElement("svg", { className: "w-5 h-5", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", strokeWidth: 1.5, stroke: "currentColor", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgHamburger);
export { ForwardRef as ReactComponent };
